// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.grid__o2d7 {
  display : grid;
  grid-template-columns: auto minmax(auto, 1fr);
  grid-auto-rows: minmax(var(--size-detailRow, 40px), auto);
  column-gap: 0;
  row-gap: 0;
}

.label_ci9aB {
  /* padding-top: calc( var( --size-padMedium, 16px ) / 2 );
  padding-bottom: calc( var( --size-padMedium, 16px ) / 2 );
  padding-left : var( --size-padLarge, 24px );
  padding-right : calc( var( --size-padLarge, 24px ) / 2 ); */
  display : flex;
  width : 100%;
  height : 100%;
  box-sizing: border-box;
}

.value_Wmly4 {
  /* padding-top: calc( var( --size-padMedium, 16px ) / 2 );
  padding-bottom: calc( var( --size-padMedium, 16px ) / 2 );
  padding-left : calc( var( --size-padLarge, 24px ) / 2 );
  padding-right : var( --size-padLarge, 24px ); */
  display : flex;
  width : 100%;
  height : 100%;
  box-sizing: border-box;
  position: relative;
}

.cell_x6IkX {
  display : flex;
  width : 100%;
  height : 100%;
}

.custom_JvDrw {
  padding: calc( var( --size-padMedium, 16px ) / 2 ) var( --size-padLarge, 24px );
  display : flex;
  width : 100%;
  height : 100%;
  box-sizing: border-box;
}

.customCell_eWTIb {
  grid-column: 1 / span 2;
}

.even_LkxOh {
  background : var( --color-detailEvenRow, rgba( 0, 0, 0, 0.05 ));
}

.odd_oXjxP {
  background : var( --color-detailOddRow, rgba( 0, 0, 0, 0.0 ));
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-attributes/lib/detail/shared/DetailListCard.css"],"names":[],"mappings":";AACA;EACE,cAAc;EACd,6CAA6C;EAC7C,yDAAyD;EACzD,aAAa;EACb,UAAU;AACZ;;AAEA;EACE;;;6DAG2D;EAC3D,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE;;;iDAG+C;EAC/C,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,+EAA+E;EAC/E,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,6DAA6D;AAC/D","sourcesContent":["\n.grid {\n  display : grid;\n  grid-template-columns: auto minmax(auto, 1fr);\n  grid-auto-rows: minmax(var(--size-detailRow, 40px), auto);\n  column-gap: 0;\n  row-gap: 0;\n}\n\n.label {\n  /* padding-top: calc( var( --size-padMedium, 16px ) / 2 );\n  padding-bottom: calc( var( --size-padMedium, 16px ) / 2 );\n  padding-left : var( --size-padLarge, 24px );\n  padding-right : calc( var( --size-padLarge, 24px ) / 2 ); */\n  display : flex;\n  width : 100%;\n  height : 100%;\n  box-sizing: border-box;\n}\n\n.value {\n  /* padding-top: calc( var( --size-padMedium, 16px ) / 2 );\n  padding-bottom: calc( var( --size-padMedium, 16px ) / 2 );\n  padding-left : calc( var( --size-padLarge, 24px ) / 2 );\n  padding-right : var( --size-padLarge, 24px ); */\n  display : flex;\n  width : 100%;\n  height : 100%;\n  box-sizing: border-box;\n  position: relative;\n}\n\n.cell {\n  display : flex;\n  width : 100%;\n  height : 100%;\n}\n\n.custom {\n  padding: calc( var( --size-padMedium, 16px ) / 2 ) var( --size-padLarge, 24px );\n  display : flex;\n  width : 100%;\n  height : 100%;\n  box-sizing: border-box;\n}\n\n.customCell {\n  grid-column: 1 / span 2;\n}\n\n.even {\n  background : var( --color-detailEvenRow, rgba( 0, 0, 0, 0.05 ));\n}\n\n.odd {\n  background : var( --color-detailOddRow, rgba( 0, 0, 0, 0.0 ));\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `grid__o2d7`,
	"label": `label_ci9aB`,
	"value": `value_Wmly4`,
	"cell": `cell_x6IkX`,
	"custom": `custom_JvDrw`,
	"customCell": `customCell_eWTIb`,
	"even": `even_LkxOh`,
	"odd": `odd_oXjxP`
};
export default ___CSS_LOADER_EXPORT___;
